import React, { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const Input = ({
  label,
  checked,
  onChange,
  forceCheck,
  labelPlacement,
  disableCheckbox,
}) => {
  const [inputValue, setInputValue] = useState(checked);
  const inputChange = (e) => {
    setInputValue(e.target.checked);
    onChange(e.target.checked);
  };

  useEffect(() => {
    setInputValue(checked);
  }, [checked]);

  return (
    <FormControlLabel
      label={label}
      labelPlacement={labelPlacement ?? "end"}
      //   disabled={false}
      control={
        <Checkbox
          disabled={disableCheckbox}
          checked={forceCheck ?? inputValue}
          onChange={(e) => inputChange(e)}
        />
      }
    />
  );
};

export default Input;
